import utils from '@/util'
import {
  isBlockExist, defaultHeadingText, hasTag,
  generateBlockId,
  generateBlockHash,
} from './common'

const titleAndSubLayoutThumbnail = require('@/assets/images/content-slide-layouts/layout_title_sub.svg')

const defaultHeadingStyle = {
  width: '1200px',
  height: '90px',
  transform: 'translate(30px, 220px)',
}
const headingContent = (headingText) => {
  return {
    value: `
    <p style="text-align: center;" data-mce-style="text-align: center;">
      <span style="font-size: 52px;" data-mce-style="font-size: 52px;">
        <strong>
          ${headingText}
        </strong>
      </span>
    </p>
    `,
  }
}
const subheadingContent = (subheadingText) => {
  return {
    value: `
    <p style="text-align: center;" data-mce-style="text-align: center;">
      <span style="font-size: 32px;" data-mce-style="font-size: 32px;">
        ${subheadingText}
      </span>
    </p>
  `,
  }
}
const defaultSubheadingStyle = {
  width: '1200px',
  height: '150px',
  transform: 'translate(30px, 320px)',
}
const defaultSubheadingContent = subheadingContent('Click to add subheading')

function layoutBuilder(slideId, currentCanvasBlocks) {
  if (!slideId) {
    slideId = (Math.random() + 1).toString(36).substring(6)
  }
  const newCanvasBlocks = { ...currentCanvasBlocks }
  // Add default block to make layout if not exists
  if (!isBlockExist(currentCanvasBlocks, hasTag('heading'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'heading',
      content: headingContent(defaultHeadingText),
      style: defaultHeadingStyle,
      h: generateBlockHash(),
    }
  }
  if (!isBlockExist(currentCanvasBlocks, hasTag('content'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'content',
      content: defaultSubheadingContent,
      style: defaultSubheadingStyle,
      h: generateBlockHash(),
    }
  }

  if (currentCanvasBlocks) {
    Object.keys(currentCanvasBlocks).forEach((blockId) => {
      const block = currentCanvasBlocks[blockId]
      if (block.tag === 'heading') {
        const newBlock = {
          ...block,
          id: generateBlockId(slideId),
          style: defaultHeadingStyle,
          hidden: false,
          content: headingContent(utils.extractContent(block.content.value, true) || defaultHeadingText),
          h: generateBlockHash(),

        }
        newCanvasBlocks[newBlock.id] = newBlock
        delete newCanvasBlocks[blockId]
      } else if (block.tag === 'content') {
        const newBlock = {
          ...block,
          id: generateBlockId(slideId),
          style: defaultSubheadingStyle,
          hidden: false,
          content: subheadingContent(utils.extractContent(block.content.value, true) || 'Click to add content'),
          h: generateBlockHash(),
        }
        newCanvasBlocks[newBlock.id] = newBlock
        delete newCanvasBlocks[blockId]
      } else {
        newCanvasBlocks[blockId] = {
          ...block,
          hidden: true,
        }
      }
    })
  }

  return newCanvasBlocks
}

const HeadingAndSubLayout = {
  type: 'heading-sub',
  name: 'Title and Subtitle',
  layoutThumbnailImage: titleAndSubLayoutThumbnail,
  build: layoutBuilder,
}

export default HeadingAndSubLayout
